import React from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { PopIn } from "@companion-core/shared/app/Components/PopIn";
import { useCancelPopIn } from "@companion-core/shared/app/Components/Requests/RequestDetail/CancelPopIn/hooks/useCancelPopIn";
import { CancelPopInProps } from "./cancelPopIn.model";

export const CancelPopIn = ({ requestData, onClose, isOpen }: CancelPopInProps) => {
  const { t } = useTranslation();
  const { popInArgs } = useCancelPopIn({
    requestData,
    loader: <Spin size="large" />,
    onClose,
  });

  if (!popInArgs) {
    return null;
  }

  return (
    <PopIn
      isOpen={isOpen}
      {...popInArgs}
      dialogTitleId="cancel-popin__title"
      primaryButton={
        popInArgs.primaryButton
          ? {
              ...popInArgs.primaryButton,
              accessibilityLabel: popInArgs.secondaryButton
                ? t("request.my-requests.detail.popin.cancel.primary-button.aria-label")
                : undefined,
            }
          : undefined
      }
      secondaryButton={
        popInArgs.secondaryButton
          ? {
              ...popInArgs.secondaryButton,
              accessibilityLabel: t(
                "request.my-requests.detail.popin.cancel.secondary-button.aria-label"
              ),
            }
          : undefined
      }
    />
  );
};
